import { useState } from 'react';

import { Avatar } from '@/components/ri/Avatar';
import { Btn } from '@/components/ri/Btn';
import { useAuth } from '@/hooks/useAuth';
import { getImpersonation, stopImpersonation } from '@/lib/impersonation';

export const IMPERSONATION_BANNER_HEIGHT = 40;

export function ImpersonationBanner() {
  const { user } = useAuth();
  const [stopping, setStopping] = useState(false);

  const stored = getImpersonation();
  const serverInfo = user?.impersonation ?? null;
  const active = stored !== null || serverInfo !== null;

  if (!active) return null;

  const displayName = stored?.displayName || user?.displayName || 'user';
  const email = stored?.email || user?.email || '';
  const realName = serverInfo?.realDisplayName ?? null;

  const handleStop = () => {
    setStopping(true);
    void stopImpersonation();
  };

  return (
    <div
      role="status"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 250,
        minHeight: 'calc(40px + env(safe-area-inset-top, 0px))',
        paddingTop: 'env(safe-area-inset-top, 0px)',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: 0,
        background: 'var(--warning-soft)',
        borderBottom: '2px solid var(--warning)',
        color: 'var(--text-primary)',
        fontSize: 12.5,
      }}
    >
      <Avatar name={displayName} size={22} />
      <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        Viewing as <strong>{displayName}</strong>
        {email ? <span className="ri-mono" style={{ color: 'var(--text-secondary)' }}> ({email})</span> : null}
        {realName ? (
          <span style={{ color: 'var(--text-tertiary)' }}> · {realName}</span>
        ) : null}
      </span>
      <div style={{ flex: 1 }} />
      <Btn size="sm" onClick={handleStop} loading={stopping}>
        Stop impersonating
      </Btn>
    </div>
  );
}
